import { Tabs, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import { MediaKind } from '@/models/device.models';

type MediaKindTabsProps = {
  mediaKind: MediaKind;
  setMediaKind: (type: MediaKind) => void;
};

export function MediaKindTabs({ mediaKind, setMediaKind }: MediaKindTabsProps) {
  return (
    <Tabs
      value={mediaKind}
      onValueChange={(type) => {
        setMediaKind(type as MediaKind);
      }}
      className="bg-secondary grid rounded-xl"
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="Original">Original</TabsTrigger>
        <TabsTrigger value="Processed">Processed</TabsTrigger>
        <TabsTrigger value="Masked">Masked</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
